export const DIVISION_PROVIDERS = [
  {
    id: 1000,
    name: 'Premier Food Safety',
    code: 'PFS',
  },
  {
    id: 2000,
    name: 'Apex Workforce Solutions',
    code: 'APEX',
  },
];

export const DEFAULT_DIALOG_WIDTH = 480;
